import axios from 'axios';
import '../config.js';

const appendParam = (params, key, value) => {
  if (value === null || value === undefined || value === '') {
    return;
  }
  params.append(key, String(value));
};

const appendDateRangeParams = (params, query = {}) => {
  appendParam(params, 'initDate', query.initDate);
  appendParam(params, 'endDate', query.endDate);
};

const buildScopeQueryString = (query = {}) => {
  const params = new URLSearchParams();
  appendDateRangeParams(params, query);
  appendParam(params, 'page', Number.isFinite(Number(query.page)) ? Number(query.page) : 0);
  appendParam(params, 'pageSize', Number.isFinite(Number(query.pageSize)) ? Number(query.pageSize) : 100);
  return params.toString();
};

const buildDateRangeQueryString = (query = {}) => {
  const params = new URLSearchParams();
  appendDateRangeParams(params, query);
  return params.toString();
};

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    Authorization: `Bearer ${token}`,
  };
};

const addOptionalAppProvider = (url, appProviderId) => {
  let nextUrl = url;
  if (appProviderId !== null && appProviderId !== undefined && appProviderId !== '') {
    const sep = nextUrl.includes('?') ? '&' : '?';
    nextUrl = `${nextUrl}${sep}appProviderId=${appProviderId}`;
  }
  return nextUrl;
};

const getScopedAudit = async (path, query, appProviderId) => {
  const qs = buildScopeQueryString(query);
  const baseUrl = global.config.url + `${path}${qs ? `?${qs}` : ''}`;
  const url = addOptionalAppProvider(baseUrl, appProviderId);

  const response = await axios.get(url, {
    headers: getAuthHeaders(),
  });

  return Array.isArray(response.data) ? response.data : [];
};

/**
 * @param {number} locationId
 * @param {import('./types/supportAudit').SupportAuditScopeQueryParams} query
 * @returns {Promise<import('./types/supportAudit').SupportAuditLogRecord[]>}
 */
export const getSupportAuditByLocation = async (locationId, query, appProviderId) => {
  return getScopedAudit(`/SupportAudit/location/${locationId}`, query, appProviderId);
};

/**
 * @param {number} clientId
 * @param {import('./types/supportAudit').SupportAuditScopeQueryParams} query
 * @returns {Promise<import('./types/supportAudit').SupportAuditLogRecord[]>}
 */
export const getSupportAuditByClient = async (clientId, query, appProviderId) => {
  return getScopedAudit(`/SupportAudit/client/${clientId}`, query, appProviderId);
};

/**
 * @param {number} accessPointId
 * @param {import('./types/supportAudit').SupportAuditScopeQueryParams} query
 * @returns {Promise<import('./types/supportAudit').SupportAuditLogRecord[]>}
 */
export const getSupportAuditByAccessPoint = async (accessPointId, query, appProviderId) => {
  return getScopedAudit(`/SupportAudit/accesspoint/${accessPointId}`, query, appProviderId);
};

/**
 * @param {string} hubId
 * @param {string} relayId
 * @param {import('./types/supportAudit').SupportAuditScopeQueryParams} query
 * @returns {Promise<import('./types/supportAudit').SupportAuditLogRecord[]>}
 */
export const getSupportAuditByHubRelay = async (hubId, relayId, query, appProviderId) => {
  return getScopedAudit(
    `/SupportAudit/hubrelay/${encodeURIComponent(String(hubId))}/${encodeURIComponent(String(relayId))}`,
    query,
    appProviderId,
  );
};

/**
 * @param {import('./types/supportAudit').SupportAuditScopeQueryParams} query
 * @returns {Promise<import('./types/supportAudit').SupportAuditLogRecord[]>}
 */
export const getSupportAuditByDateRange = async (query, appProviderId) => {
  const qs = buildDateRangeQueryString(query);
  const baseUrl = global.config.url + `/SupportAudit/daterange${qs ? `?${qs}` : ''}`;
  const url = addOptionalAppProvider(baseUrl, appProviderId);

  const response = await axios.get(url, {
    headers: getAuthHeaders(),
  });

  return Array.isArray(response.data) ? response.data : [];
};

const supportAuditApi = {
  getSupportAuditByLocation,
  getSupportAuditByClient,
  getSupportAuditByAccessPoint,
  getSupportAuditByHubRelay,
  getSupportAuditByDateRange,
};

export default supportAuditApi;
